// iter153 — Father / Husband relation picker for Vendor & CCH forms.
//
// Behaves like a radio: exactly one of {father, husband} is ticked at a
// time; default is "father". Hidden for Agency entities.
//
// Backend: the chosen value is persisted on the Vendor / CCH record as
// `relationType` (see server.py models). The actual name is still stored
// in `fatherName` / `fatherNameOdia` — this picker only chooses the
// LABEL / HONORIFIC. Legacy records without `relationType` behave as
// "father".
//
// Also exports helper functions `relationLabelEn` / `relationLabelOdia`
// used by every form, PDF row and report that needs to show the right
// honorific.
import { Check } from "lucide-react";

export const RELATION_OPTIONS = [
  { value: "father", en: "Father", od: "ପିତା" },
  { value: "husband", en: "Husband", od: "ସ୍ୱାମୀ" },
];

export function relationLabelEn(rel) {
  return rel === "husband" ? "Husband" : "Father";
}
export function relationLabelOdia(rel) {
  return rel === "husband" ? "ସ୍ୱାମୀ" : "ପିତା";
}
export function nameLabelEn(rel) {
  return `${relationLabelEn(rel)}'s Name (English)`;
}
export function nameLabelOdia(rel) {
  return rel === "husband" ? "ସ୍ୱାମୀଙ୍କ ନାମ (ଓଡ଼ିଆ)" : "ପିତାଙ୍କ ନାମ (ଓଡ଼ିଆ)";
}

export default function RelationPicker({ value, onChange, testIdPrefix }) {
  const current = value === "husband" ? "husband" : "father";
  return (
    <div
      className="flex gap-2"
      role="radiogroup"
      aria-label="Relation: Father or Husband"
      data-testid={`${testIdPrefix}-relation-group`}
    >
      {RELATION_OPTIONS.map((opt) => {
        const active = current === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={active}
            data-testid={`${testIdPrefix}-relation-${opt.value}`}
            onClick={() => onChange(opt.value)}
            className={`flex min-h-[48px] flex-1 items-center justify-center gap-2 rounded-xl border-2 px-4 text-sm font-semibold transition-all active:scale-[0.98] ${
              active
                ? "border-brand-600 bg-brand-600 text-white shadow"
                : "border-slate-200 bg-white text-slate-700 hover:border-slate-300"
            }`}
          >
            <span
              className={`grid h-5 w-5 shrink-0 place-items-center rounded border-2 ${
                active ? "border-white bg-white/20" : "border-slate-300 bg-white"
              }`}
            >
              {active && <Check className="h-3.5 w-3.5 text-white" strokeWidth={3} />}
            </span>
            <span>
              {opt.en} <span className="opacity-80">/ {opt.od}</span>
            </span>
          </button>
        );
      })}
    </div>
  );
}
